import * as ng from 'angular';
import {UISelectService} from '../../../../services/ui-select.service';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {ArchiSmallERRORS} from '../../../../commons/errors';

class ConservazioneCaricaDocumentoCmStep2Controller implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$filter',
    'UiSelectService'
  ];

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService,
  ) {
    $scope.pageHeader = 'Carica Documento';
    $scope.pageSubHeader = 'Inserisci le informazioni obbligatorie per la conservazione';

    if (store.get('conservazioneClasseDocumentale') === null) {
      $state.go('home.conservazione-carica-documento-step1');
      return;
    }

    $scope.classeDocumentale = store.get('conservazioneClasseDocumentale').value;

    $scope.years = [];
    const curr_year = new Date().getFullYear();
    for (let i = curr_year - 1; i <= curr_year; i++) {
      $scope.years.push(i);
    }
    const years = store.get('user').previousYears[$scope.classeDocumentale.split('-').join('_')] as {
      anno: number,
      scadenza: string
    }[];
    if (years) {
      for (let year of years) {
        if (new Date(year.scadenza) > new Date()) {
          $scope.years.push(year.anno);
        }
      }
    }

    $scope.anagraficaVettoreIsNew = true;

    $scope.vettore = {};
    $scope.PIVAType = new RegExp('(^[0-9]{11}$)|ND');
    $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{16}$');

    let isNomeVettoreDisabled;
    let isCognomeVettoreDisabled;
    let isRagioneSocialeVettoreDisabled;
    let isVettoreCFDisabled;
    let isVettorePIVADisabled;

    $scope.prev = () => {
      $scope.setConservazioneSettings();
      $state.go('home.conservazione-carica-documento-step1', {'classeDocumentale': $scope.classeDocumentale});
    };

    $scope.saveAnagrafica = async () => {
      let anagraficaVettore = {
        email_pec: '',
        emails: [],
        nome: $scope.settings.vettoreNome,
        cognome: $scope.settings.vettoreCognome,
        company_name: $scope.settings.vettoreRagioneSociale,
        fiscal_code: $scope.settings.vettoreCodiceFiscale,
        piva: $scope.settings.vettorePiva,
        type: $scope.settings.vettoreRagioneSociale !== '' ? 2 : `${$scope.settings.vettoreNome} ${$scope.settings.vettoreCognome}`.trim() !== '' ? 1 : 2
      };
      const anagrafiche = [];
      if ($scope.anagraficaVettoreIsNew) {
        anagrafiche.push(anagraficaVettore);
      }
      const results = [];
      for (const anagrafica of anagrafiche) {
        try {
          await ArchiSmallServices.insertAnagrafica(anagrafica);
          results.push(true);
        } catch (err) {
          if (err.errorCode !== ArchiSmallERRORS.DUPLICATE_KEY) {
            $rootScope.alert('error', err);
          }
          results.push(false);
        }
      }
      return new Promise((resolve, reject) => {
        if (results.every(v => v) || results.length === 0) {
          resolve(true);
        }
        reject(false);
      });
    };

    $rootScope.formsubmitted = false;

    $scope.setConservazioneSettings = () => {

      $scope.settings.vettoreRagioneSociale = $scope.vettore.anagrafica;

      let classeDocumentale = $scope.settings.classeDocumentale.key;

      let userSettings = {
        'key': classeDocumentale,
        'value': $scope.settings
      };

      ArchiSmallServices.setConservazioneSettings(userSettings)
        .then((response: any) => {
          // ??
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    // <editor-fold desc='getConservazioneSettings'>
    $scope.getConservazioneSettings = () => {
      $rootScope.readyToUse = false;
      $scope.currentClasseDocumentale = $scope.classeDocumentale;
      ArchiSmallServices.getConservazioneSettings($scope.classeDocumentale)
        .then((response: any) => {
          if (response !== undefined && response !== '') {
            $scope.settings = response.value;
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;

            $scope.vettore.anagrafica = $scope.settings.vettoreRagioneSociale;
            isNomeVettoreDisabled = $scope.settings.vettoreNome !== '' && $scope.settings.vettoreNome !== undefined;
            isCognomeVettoreDisabled = $scope.settings.vettoreCognome !== '' && $scope.settings.vettoreCognome !== undefined;
            isRagioneSocialeVettoreDisabled = $scope.settings.vettoreRagioneSociale !== '' && $scope.settings.vettoreRagioneSociale !== undefined;
            isVettoreCFDisabled = $scope.settings.vettoreCodiceFiscale !== '' && $scope.settings.vettoreCodiceFiscale !== undefined;
            isVettorePIVADisabled = $scope.settings.vettorePiva !== '' && $scope.settings.vettorePiva !== undefined;

          } else {
            $scope.settings = $scope.getSettingsDefault();
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
            $scope.filesIndex = $scope.settings.files.length;
            $rootScope.filesUploadedNumber = $scope.filesIndex;
          }
          $rootScope.readyToUse = true;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    if ($scope.classeDocumentale !== '') {
      $scope.getConservazioneSettings();
    }

    $scope.getAnagraficaTypeaheadValues = () => {
      ArchiSmallServices.getAnagraficaTypeaheadValues()
        .then((response: any) => {
          $scope.anagrafica = response;

        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.getAnagraficaTypeaheadValues();

    $scope.autocompleteFields = (item, tipo: string) => {
      if (item !== undefined && typeof item === 'object') {
        if (tipo === 'vettore') {
          if (item._id === -1) {
            $scope.settings.vettoreNome = '';
            $scope.settings.vettoreCognome = '';
            $scope.settings.vettoreRagioneSociale = '';
            $scope.settings.vettorePiva = '';
            $scope.settings.vettoreCodiceFiscale = '';
            isNomeVettoreDisabled = false;
            isCognomeVettoreDisabled = false;
            isRagioneSocialeVettoreDisabled = false;
            isVettoreCFDisabled = false;
            isVettorePIVADisabled = false;
            $scope.anagraficaVettoreIsNew = true;
          } else {
            $scope.settings.vettoreNome = item.nome;
            $scope.settings.vettoreCognome = item.cognome;
            $scope.settings.vettoreRagioneSociale = item.company_name;
            $scope.settings.vettorePiva = item.piva;
            $scope.settings.vettoreCodiceFiscale = item.fiscal_code;
            isNomeVettoreDisabled = item.nome !== '' && item.nome !== undefined;
            isCognomeVettoreDisabled = item.cognome !== '' && item.cognome !== undefined;
            isRagioneSocialeVettoreDisabled = item.company_name !== '' && item.company_name !== undefined;
            isVettoreCFDisabled = item.fiscal_code !== '' && item.fiscal_code !== undefined;
            isVettorePIVADisabled = item.piva !== '' && item.piva !== undefined;
            $scope.anagraficaVettoreIsNew = false;
          }
        }
      }
    };

    $scope.clear = ($event, $select) => {
      UISelectService.clear($event, $select);
      if ($select.ngModel.$name === 'vettore') {
        $scope.vettore.anagrafica = '';
        $scope.settings.vettorePiva = '';
        $scope.settings.vettoreCodiceFiscale = '';
        isVettoreCFDisabled = false;
        isVettorePIVADisabled = false;
        $scope.anagraficaVettoreIsNew = false;
      }
    };

    $scope.isNomeVettoreDisabled = () => {
      return isNomeVettoreDisabled;
    };
    $scope.isCognomeVettoreDisabled = () => {
      return isCognomeVettoreDisabled;
    };
    $scope.isRagioneSocialeVettoreDisabled = () => {
      return isRagioneSocialeVettoreDisabled;
    };
    $scope.isVettoreCFDisabled = () => {
      return isVettoreCFDisabled;
    };
    $scope.isVettorePIVADisabled = () => {
      return isVettorePIVADisabled;
    };

    /* tslint:enable:no-string-literal */
    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    $scope.refreshResults = ($select) => {
      UISelectService.refreshResults($select);
    };

    $scope.dpOpened = {
      dataDocumento: false,
    };

    $scope.openDP = ($event, opened) => {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };

    $scope.openCMModal = async (size) => {

      try {
        await $scope.saveAnagrafica();
      } catch (err) {
        return;
      }

      $scope.settings.dataDocumento = $filter('date')($scope.settings.dataDocumento, 'yyyy-MM-dd');

      let WorkerChatModal = $uibModal.open({
        animation: true,
        component: 'workerCmModalComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: () => {
            return $scope.settings;
          }
        }
      });
    };
    // </editor-fold>

  }
}

export const ConservazioneCaricaDocumentoCmStep2Component: ng.IComponentOptions = {
  template: require('./conservazione-carica-documento-cm-step2.html'),
  controller: ConservazioneCaricaDocumentoCmStep2Controller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-cm-step2/conservazione-carica-documento-cm-step2.ts